module.exports = __webpack_public_path__ + "static/media/AgentCallAuto.000005f3.svg";